<ul class="timeline">
	<li *ngFor="let item of selectedHistorique">
		<div>
			{{ item.dateModification | dateFormat : dateFormatType.DDMMYYYYHH }}
			<h5 style="margin-bottom: 0px" *ngIf="item.utilisateurModification?.nom && item.utilisateurModification?.prenom">
				- {{ item.utilisateurModification?.nom + ' ' + item.utilisateurModification?.prenom }}
			</h5>
			
			<h5 style="margin-bottom: 0px" *ngIf="!item.utilisateurModification">
				- Système
			</h5>
		</div>
		<p>{{ item.message }}</p>
	</li>
</ul>
<div *ngIf="selectedHistorique?.length === 0">
	<span translate="Panel.PanelVide"></span>
</div>
